/* eslint-disable no-unused-vars */
import React, { createContext, useContext, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { useHistory, useLocation, useParams } from 'react-router';

import { actions } from '../features/work-order-slice';
import { fetchSystemValid } from '../features/system-thunk';
import { queryContactList, 
  queryProductList, queryProductUnitList, 
  querySpecList, querySpecUnitList,
  queryMaterialList, queryMaterialUnitList,
  queryProcessList, queryProcessUnitList,  
  queryWorkOrder, 
  changeStatus } from '../features/work-order-thunk';

import { PillStatus } from './work-widget';

import {
  delaySaveWork,
  performSearch,
  read,
  removeWork,
  delaySaveSpec,
  delaySaveBom,
  delaySaveProcess,
  delaySaveJob,
  removeSpec,
  removeBom,
  removeProcess,
  removeJob,
  copyWork,
} from '../controllers/work-order';

import { ZetaSection, ZetaGroup, ZetaDataList, showAlert } from '../zeta-widget';
import { ProcessBar } from '../zeta-widget/widgets/process-bar';
import { loadLayout, loadTemplate } from '../tools/layout-tool';
import { loadDataList } from '../tools/option-tool';

import { useAuth } from '../use-auth';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { TextClickable } from '../widgets';

const defaultEnquiryLayout = [
  {
    name: 'filter',
    file: 'work-order-filter',
    size: 'full',
    class: '',
  },
  {
    name: 'found',
    file: 'work-order-found',
    size: 'full',
    class: 'table-responsive-sm',
  },
];

const delaySearch = 500;
let timerSearch = null;

function handleSearch(dispatch, cond) {
  if (timerSearch) clearTimeout(timerSearch);
  timerSearch = setTimeout(() => {
    // performSearch(filter).then((found) => callback(found));
    // Using createAsyncThunk in work-order-thunk, extraReducers in work-order-slice
    dispatch(queryWorkOrder(cond))
  }, delaySearch);
}

function openWorkOrder(dispatch, _id, pane='sum') {
  read(_id).then((data) => {
    dispatch(actions.setData(data));
    dispatch(actions.setActiveSection('entry'));
    dispatch(actions.setActivePane(pane));
  });
}

export function WorkOrderApp(props) {
  const enquiryLayout = useSelector((state) => state.orders.enquiryLayout);
  const entryTemplates = useSelector((state) => state.orders.entryTemplates);
  const searchData = useSelector((state) => state.orders.searchData);
  const data = useSelector((state) => state.orders.data);

  const validWorkStatus = useSelector((state) => state.orders.validWorkStatus);
  const contactList = useSelector((state) => state.app.contact_list);
  const productList = useSelector((state) => state.app.product_list);
  const productUnitList = useSelector((state) => state.app.product_unit_list);
  const specList = useSelector((state) => state.app.spec_list);
  const specUnitList = useSelector((state) => state.app.spec_unit_list);
  const matList = useSelector((state) => state.app.mat_list);
  const matUnitList = useSelector((state) => state.app.mat_unit_list);
  const processList = useSelector((state) => state.app.process_list);
  const processUnitList = useSelector((state) => state.app.process_unit_list);

  const activePane = useSelector(state => state.orders.activePane);
  const activeSection = useSelector(state => state.orders.activeSection);
  const processBar = useSelector(state => state.orders.processBar);

  const auth = useAuth();
  const [lang, setLang] = useState(auth.lang || 'en');

  const dispatch = useDispatch();
  const location = useLocation();
  const { work_id } = useParams();

  useEffect(() => {
    loadTemplate(defaultEnquiryLayout, (v) => {
      // console.info(v);
      dispatch(actions.setEnquiryLaout(v));
    });

    loadLayout('work-order-layout', (v) => {
      loadTemplate(v, (t) => {
        // console.info(t);
        dispatch(actions.setEntryTemplates(t));
      });
    });

    /* Too slow, query list
    dispatch(queryContactList());
    dispatch(queryProductList());
    dispatch(querySpecList());
    dispatch(queryMaterialList());
    dispatch(queryProcessList());

    dispatch(queryProductUnitList()).then(result => {
      // console.info(result);
      if(Array.isArray(result.payload) && result.payload.legth === 0) {
        loadDataList('unit-list', 'product-unit-list');
      }
    });

    dispatch(querySpecUnitList()).then(result => {
      // console.info(result);
      if(Array.isArray(result.payload) && result.payload.legth === 0) {
        loadDataList('spec-unit-list', 'spec-unit-list');
      }
    });

    dispatch(queryMaterialUnitList()).then(result => {
      // console.info(result);
      if(Array.isArray(result.payload) && result.payload.legth === 0) {
        loadDataList('material-unit-list', 'material-unit-list');
      }
    });

    dispatch(queryProcessUnitList()).then(result => {
      // console.info(result);
      if(Array.isArray(result.payload) && result.payload.legth === 0) {
        loadDataList('time-unit-list', 'process-unit-list');
      }
    });
    
    */
    dispatch(fetchSystemValid(241)); // Work Order Status

    if(work_id && work_id !== '') {
      // console.info(`Opening ... ${work_id}`);
      const search = new URLSearchParams(location.search);
      const pane = search.get('pane') || 'sum';
      openWorkOrder(dispatch, work_id, pane);
    }

  }, [dispatch, location, work_id]);

  useEffect(() => {
    // console.info('Will search...');
    dispatch(actions.setActiveSection('search'));
    const cond = { filter: searchData.filter, status : searchData.status };
    handleSearch(dispatch, cond);
  }, [dispatch, location, searchData.filter, searchData.status]);

  const handleShowPane = useCallback(
    (pane) => {
      dispatch(actions.setActivePane(pane));

      if (pane==='spec' && specList.length===0) {
        dispatch(querySpecList());
        dispatch(querySpecUnitList()).then(result => {
          // console.info(result);
          if(Array.isArray(result.payload) && result.payload.legth === 0) {
            loadDataList('spec-unit-list', 'spec-unit-list');
          }
        });    
      }

      if (pane==='formula' && matList.length===0) {
        dispatch(queryMaterialList());
        dispatch(queryMaterialUnitList()).then(result => {
          // console.info(result);
          if(Array.isArray(result.payload) && result.payload.legth === 0) {
            loadDataList('material-unit-list', 'material-unit-list');
          }
        });  
      }

      if (pane==='process' && processList.length===0) {
        dispatch(queryProcessList());
        dispatch(queryProcessUnitList()).then(result => {
          // console.info(result);
          if(Array.isArray(result.payload) && result.payload.legth === 0) {
            loadDataList('time-unit-list', 'process-unit-list');
          }
        });        
      }
           
    },
    [dispatch, matList, processList, specList]
  );

  const handleFilterChange = useCallback(
    (e) => {
      const _data = { ...searchData };

      _data[e.target.name] = e.target.value;

      dispatch(actions.setSearchData(_data));
    },
    [dispatch, searchData]
  );

  const handleDataChange = useCallback(
    (e) => {
      const _data = { ...data };

      _data[e.target.name] = e.target.value;
      // console.info(_data);

      if (
        e.target.name === 'work_status' &&
        e.target.value === 'Z' &&
        (!_data['finish_date'] || _data['finish_date'] === '')
      ) {
        _data['finish_date'] = new Date().toISOString();
      }
      else if (e.target.name && e.target.name.match(/qty_(total|ng)/))
      {
        if (
          _data.qty_total && 
          _data.qty_ng &&
          `${_data.qty_total}` !== '' &&
          `${_data.qty_ng}` !== ''
        ) {
          const _total = parseFloat(`${_data.qty_total}`.replace(/,/g, ''));
          const _ng = parseFloat(`${_data.qty_ng}`.replace(/,/g, ''));
          _data.qty_good = _total - _ng;
        }
      }

      dispatch(actions.updateData(_data));
      // if (data._id) dispatch(actions.updateFound(_data));

      delaySaveWork(_data)
      .then((result) => {
        // console.info('Work saved', result);
        if(!data._id) {
          _data._id = result._id;
          _data.work_no = result.work_no;
          dispatch(actions.updateData(_data));
          dispatch(actions.prependFound(_data));
        } else {
          dispatch(actions.updateFound(_data));
        }
      })
      .catch(err => alert(err));
    },
    [data, dispatch]
  );

  const handleFoundClick = useCallback(
    (idx) => {
      // console.info('Click ...', idx, searchData.found[idx]);
      const _id = searchData.found[idx]._id;
      openWorkOrder(dispatch, _id);
    },
    [dispatch, searchData.found]
  );

  const handleOpen = useCallback(
    (row) => {
      if(row._id) {
        openWorkOrder(dispatch, row._id);
      }
    },
    [dispatch],
  );

  const handleApprove = useCallback(
    (value) => {
      dispatch(changeStatus({_id : value._id, work_status: 'A'}));
    },
    [dispatch],
  )

  const handleStart = useCallback(
    (value) => {
      dispatch(changeStatus({_id : value._id, work_status: 'Y'}));
    },
    [dispatch],
  )

  const handleFinish = useCallback(
    (value) => {
      dispatch(changeStatus({
        _id : value._id, 
        work_status: 'Z', 
        finish_date: new Date().toISOString()
      }))
      .then(res => {
        console.info(res);
        openWorkOrder(dispatch, value._id, 'status');
      });
    },
    [dispatch],
  )

  const handleReject = useCallback(
    (value) => {
      dispatch(changeStatus({_id : value._id, work_status: 'X'}));
    },
    [dispatch],
  )

  const handleCreateNew = useCallback(
    () => {
      dispatch(actions.createNew());
      dispatch(actions.setActiveSection('entry'));
      dispatch(actions.setActivePane(''));

      dispatch(queryContactList());
      dispatch(queryProductList());

      dispatch(queryProductUnitList()).then(result => {
        // console.info(result);
        if(Array.isArray(result.payload) && result.payload.legth === 0) {
          loadDataList('unit-list', 'product-unit-list');
        }
      });
  
    },
    [dispatch],
  )

  const handleCreateCopy = useCallback(
    () => {
      dispatch(actions.showProcessBar(true));
      dispatch(actions.setProcessBarValue(30));
      dispatch(actions.setActiveSection(''));

      copyWork(data._id)
      .then(result => {
        // console.info(result);
        dispatch(actions.setProcessBarValue(90));
        openWorkOrder(dispatch, result._id);
        dispatch(actions.showProcessBar(false));
        
        showAlert('สำเนาใบสั่งผลิตสำเร็จแล้ว', 'success', true);
      })

      dispatch(actions.setProcessBarValue(60));
    },
    [data._id, dispatch],
  )

  const handlePrintOrder = useCallback(
    () => {
      window.open('/print/order/' + data._id + `?lang=${lang}`, '_blank');
    },
    [lang, data._id],
  )

  const handlePrintProcess = useCallback(
    () => {
      window.open('/print/process/' + data._id + `?lang=${lang}`, '_blank');
    },
    [lang, data._id],
  )

  const handleRemoveOrder = useCallback(
    () => {
      confirmAlert({
        title: 'ยืนยันลบคำสั่งผลิต',
        message: `ต้องการลบคำส่ั่งผลิต ${data.work_no} หรือไม่`,
        buttons: [
          {
            label: 'ยืนยัน',
            className: "btn btn-danger",
            onClick: () => {
              removeWork(data._id)
              .then(result => {
                dispatch(actions.removeFound(data._id))
                dispatch(actions.createNew());
                dispatch(actions.setActiveSection('search'));
              })
            }
          },
          {
            label: 'ยกเลิก',
            className: "btn btn-warning",
            // onClick: () => alert('Click No')
          }
        ]
      });
    },
    [data._id, data.work_no, dispatch],
  )

  // Specifications ////////////////////////////////
  const handleSpecChange = useCallback((e, idx) => {
    // console.info(e, idx);
    dispatch(actions.updateSpec({
      idx,
      name: e.target.name,
      value: e.target.value
    }));

    const _data = {...data.specs[idx]};
    _data[e.target.name] = e.target.value;
    if(!_data.line_no) _data.line_no = idx + 1;

    delaySaveSpec(data._id, _data)
    .then((result) => {
      console.info('Spec saved', result);

      if(!_data._id) {
        dispatch(actions.updateSpec({ idx, name: '_id', value: result._id }));
      }
    })
  }, [data._id, data.specs, dispatch]);

  const handleSpecAdd = useCallback(
    () => {
      dispatch(actions.addSpec());
    },
    [dispatch],
  )

  const handleSpecRemove = useCallback(
    (idx) => {
      if (data.specs[idx]._id) {
        removeSpec(data.specs[idx]._id)
        .then((result) => {
          console.info('Spec removed', result);

          dispatch(actions.removeSpec({idx}));
        });
      } else {
        dispatch(actions.removeSpec({idx}));
      }
    },
    [data.specs, dispatch],
  )
  // End Specifications /////////////////////////////

  // Formulation ////////////////////////////////
  const handleFormulaChange = useCallback((e, idx) => {
    // console.info(e, idx);
    dispatch(actions.updateFormula({
      idx,
      name: e.target.name,
      value: e.target.value
    }));

    const _data = {...data.formulas[idx]};
    _data[e.target.name] = e.target.value;
    if(!_data.line_no) _data.line_no = idx + 1;

    delaySaveBom(data._id, _data)
    .then((result) => {
      console.info('Formula saved', result);

      if(!_data._id) {
        dispatch(actions.updateFormula({ idx, name: '_id', value: result._id }));
      }
    })
  }, [data._id, data.formulas, dispatch]);

  const handleFormulaAdd = useCallback(
    () => {
      dispatch(actions.addFormula());
    },
    [dispatch],
  )

  const handleFormulaRemove = useCallback(
    (idx) => {
      if (data.formulas[idx]._id) {
        removeBom(data.formulas[idx]._id)
        .then((result) => {
          console.info('Spec removed', result);

          dispatch(actions.removeFormula({idx}));
        });
      } else {
        dispatch(actions.removeFormula({idx}));        
      }
    },
    [data.formulas, dispatch],
  )
  // End Formulation /////////////////////////////

  // Process ////////////////////////////////
  const handleProcessChange = useCallback((e, idx) => {
    // console.info(e, idx);
    dispatch(actions.updateProcess({
      idx,
      name: e.target.name,
      value: e.target.value
    }));

    const _data = {...data.process[idx]};
    _data[e.target.name] = e.target.value;
    if(!_data.line_no) _data.line_no = idx + 1;

    delaySaveProcess(data._id, _data)
    .then((result) => {
      console.info('Process saved', result);

      if(!_data._id) {
        dispatch(actions.updateProcess({ idx, name: '_id', value: result._id }));
      }
    })
  }, [data._id, data.process, dispatch]);

  const handleProcessAdd = useCallback(
    () => {
      dispatch(actions.addProcess());
    },
    [dispatch],
  )

  const handleProcessRemove = useCallback(
    (idx) => {
      if (data.process[idx]._id) {
        removeProcess(data.process[idx]._id)
        .then((result) => {
          console.info('Process removed', result);

          dispatch(actions.removeProcess({idx}));
        });
      } else {
        dispatch(actions.removeProcess({idx}));
      }
    },
    [data.process, dispatch],
  )
  // End Process /////////////////////////////

  // Job Status ////////////////////////////////
  const handleJobChange = useCallback((e, idx) => {
    // console.info(e, idx);
    dispatch(actions.updateJob({
      idx,
      name: e.target.name,
      value: e.target.value
    }));

    const _data = {...data.jobs[idx]};
    _data[e.target.name] = e.target.value;

    delaySaveJob(data._id, _data)
    .then((result) => {
      console.info('Job saved', result);

      if(!_data._id) {
        dispatch(actions.updateJob({ idx, name: '_id', value: result._id }));
      }
    })
  }, [data._id, data.jobs, dispatch]);

  const handleJobAdd = useCallback(
    () => {
      dispatch(actions.addJob());
    },
    [dispatch],
  )

  const handleJobRemove = useCallback(
    (idx) => {
      if (data.jobs[idx]._id) {
        removeJob(data.jobs[idx]._id)
        .then((result) => {
          console.info('Job removed', result);

          dispatch(actions.removeJob({idx}));
        });
      } else {
        dispatch(actions.removeJob({idx}));
      }
    },
    [data.jobs, dispatch],
  )
  // End Job Status /////////////////////////////

  const handlers = {
    handleOpen,
    handleApprove,
    handleStart,
    handleFinish,
    handleReject,

    handleFoundClick,
    handleRemoveOrder,

    handleSpecChange,
    handleSpecAdd,
    handleSpecRemove,

    handleFormulaChange,
    handleFormulaAdd,
    handleFormulaRemove,

    handleProcessChange,
    handleProcessAdd,
    handleProcessRemove,

    handleJobChange,
    handleJobAdd,
    handleJobRemove,

    handleShowSpec: () => handleShowPane('spec'),
    handleShowFormula: () => handleShowPane('formula'),
    handleShowProcess: () => handleShowPane('process'),
    handleShowStatus: () => handleShowPane('status'),
    handleShowSummary: () => handleShowPane('sum'),
    handleShowJobRecord: () => handleShowPane('job-record'),
  };
  
  const text_click = ({work_no, _id}) => <React.Fragment>
    <TextClickable text={work_no} click={() => openWorkOrder(dispatch, _id)} />
    <br />
  </React.Fragment>

  const _this = {
    auth,
    lang: auth.lang || 'en',
    locale: auth.lang === 'th'? 'th-TH': 'en-UK',

    activePane,
    activeSection,
    validWorkStatus,

    pill_status: (v) => <PillStatus>{v}</PillStatus>,
    text_click,

    handlers,
  };

  return (
    <React.Fragment>
      <ActionMenuBar 
        dispatch={dispatch}
        onCreateNew={handleCreateNew}
        onCreateCopy={handleCreateCopy}
        onPrintOrder={handlePrintOrder}
        onPrintProcess={handlePrintProcess}
      />

      {processBar.show && <div className="row my-4">
        <div className="col-md-10 offset-md-1">
          <ProcessBar em={{color: 'danger', value: processBar.value}} />
        </div>
      </div>}

      <ZetaSection title="สืบค้น" name="search" app={_this}>
        <div className="row">
          {enquiryLayout &&
            enquiryLayout.map((t, i) => {
              return (
                <ZetaGroup
                  key={i}
                  app={_this}
                  em={t}
                  size={t.size}
                  addClass={t.class || ''}
                  template={t.template}
                  data={searchData}
                  onChange={handleFilterChange}
                />
              );
            })}
        </div>
      </ZetaSection>

      <ZetaSection title="คำสั่งผลิต" name="entry" app={_this}>
        <div className="row">
          {entryTemplates &&
            entryTemplates.map((t, i) => {
              return (
                <ZetaGroup
                  key={i}
                  app={_this}
                  em={t}
                  size={t.size}
                  addClass={t.class || ''}
                  template={t.template}
                  data={data}
                  onChange={handleDataChange}
                />
              );
            })}
        </div>
      </ZetaSection>

      <ZetaDataList id="customer-list" options={contactList} />
      <ZetaDataList id="product-list" options={productList} />
      <ZetaDataList id="product-unit-list" options={productUnitList} />
      <ZetaDataList id="spec-list" options={specList} />
      <ZetaDataList id="spec-unit-list" options={specUnitList} />
      <ZetaDataList id="material-list" options={matList} />
      <ZetaDataList id="material-unit-list" options={matUnitList} />
      <ZetaDataList id="process-list" options={processList} />
      <ZetaDataList id="process-unit-list" options={processUnitList} />


    </React.Fragment>
  );
}

function ActionMenuBar(props) {
  const selectOrderReady = createSelector(state => state.orders, orders => {
    return (orders.activeSection === 'entry' && orders.data && orders.data._id && orders.data._id !== '')
  })
  const showExtButton = useSelector(selectOrderReady);
  const { dispatch } = props;
  const history = useHistory();

  return (
    <div className="row">
      <div className="col-11 col-md-7 ml-2">
        {history.length > 1 && <button type="button"
          className={"btn btn-warning btn-sm py-1 mr-2 " + ( showExtButton ? '' : 'd-none' )}
          onClick={() => {history.goBack()}}
        >
          <i className="fas fa-arrow-circle-left"></i>
        </button>}

        <button type="button"
          className="btn btn-info btn-sm py-1 mr-2"
          onClick={() => dispatch(actions.setActiveSection('search'))}
        >
          สืบค้น
        </button>

        <button type="button"
          className="btn btn-info btn-sm py-1 mr-2"
          onClick={props.onCreateNew}
        >
          สร้างใหม่
        </button>

        <button type="button"
          className={"btn btn-info btn-sm py-1 mr-2 " + ( showExtButton ? '' : 'd-none' )}
          onClick={props.onCreateCopy}
        >
          สำเนา
        </button>
      </div>

      <div className="col-11 col-md-4 ml-2 mt-2 mt-md-0  text-right">
        <button type="button"
          className={"btn btn-primary btn-sm py-1 mr-2 " + ( showExtButton ? '' : 'd-none' )}
          onClick={props.onPrintProcess}
        >
          <i className="fas fa-print"></i> ขั้นตอน
        </button>
        <button type="button"
          className={"btn btn-primary btn-sm py-1 mr-2 " + ( showExtButton ? '' : 'd-none' )}
          onClick={props.onPrintOrder}
        >
          <i className="fas fa-print"></i> ประวัติ
        </button>
      </div>
    </div>
  )
}
